/*SYSTEM IMPORTS*/
import React from 'react'
import { Viewer } from '@toast-ui/react-editor';

import './style'
import './media'

import Img from "components/Img";

/*Ui*/
import Cont from 'components/ui/Cont'
import ListServices, { ServiceItem } from 'components/ui/ListServices'
import ActionWrapp from 'components/ui/ActionWrapp'
import Btn from 'components/ui/Btn'
import ImageService1 from './images/service1.jpg'
import ImageService2 from './images/service2.jpg'
import ImageService3 from './images/service3.jpg'
import ImageService4 from './images/service4.jpg'
import ImageService5 from './images/service5.jpg'
import ImageService6 from './images/service6.jpg'
import {Helpers} from "../../../api";
import {IsIsset} from "../../../helpers/ValueTests";

/*CORES*/
import AppCore from 'cores/AppCore'

/*Images*/

const ContServices = ({
   id,
   value: {
       title = AppCore.Interfaces.t( "DoctorLanding.Ui.ContServices.Index.Title" ),
       service = [] }
    }) => {

    const [list, setList] = React.useState( service.limit(6) )
    const [limit, setLimit] = React.useState( true )

    const limitList = () =>{
        setLimit( true )
        setList( service.limit(6) )
    }
    const unlimitList = () =>{
        setLimit( false )
        setList( service )
    }

    let main_title =  AppCore.Interfaces.t( "DoctorLanding.Ui.ContServices.Index.Title" )

    if(IsIsset(title)) {
        main_title = title
    }

    return(
        <>
            {list.length > 0 &&
            <Cont id={`block-${id}`} className="cont-services">
                <h2>
                    { main_title }
                </h2>
                <ListServices>
                    {list.map( item => (
                        <ServiceItem
                            key={item.id}
                            image={
                                <Img src={`${Helpers.GetImage(item.image[0], "253_251")}`} externals div/>
                            }
                            title={item.title}
                        >
                            <Viewer initialValue={item.lead} />
                        </ServiceItem>
                    ))}
                </ListServices>
                { service.length > 6 && <ActionWrapp center>
                    { limit &&
                    <Btn
                        border
                        btnBigPadding
                        onClick={ unlimitList }>
                        { AppCore.Interfaces.t( "DoctorLanding.Ui.ContServices.Index.ButtonShowAll" ) }
                    </Btn> }
                    { !limit &&
                    <Btn
                        border
                        btnBigPadding
                        onClick={ limitList }>
                        { AppCore.Interfaces.t( "DoctorLanding.Ui.ContServices.Index.ButtonHidden" ) }
                    </Btn> }
                </ActionWrapp> }
            </Cont>
            }
        </>

    )
}

export default ContServices